import { Color } from '@diritto/common/style/color';

interface CheckBoxNewIconProps {
  className?: string;
  checked?: boolean;
}

export const CheckBoxIcon = ({ className, checked }: CheckBoxNewIconProps) => (
  <svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 3C0 1.34315 1.34315 0 3 0H21C22.6569 0 24 1.34315 24 3V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V3Z"
      fill={checked ? Color.Primary500 : Color.White}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.15127 14.9096L17.0305 7.03046L18.2426 8.24264L9.15127 17.334L4.90863 13.0914L6.12081 11.8792L9.15127 14.9096Z"
      fill={Color.White}
    />
  </svg>
);
